import { useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from "src/@/components/ui/popover";
import { Input } from "src/@/components/ui/input";
import { Button } from "src/@/components/ui/button";
import v2_actionCriarEstagioFunil from 'src/actions/v2/cliente/v2_actionCriarEstagioFunil';

export default function PopoverCriarEstagio({
  user,
  cliente,
  open,
  pipelineId,
  id,
  anchorEl,
  onClose,
  onCallback
}) {
  const [nome, setNome] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleCriarEstagioFunil() {
    try {
      let data = {
        scope: {
          nome:nome,
          pipeline_id: pipelineId,
          criado_por: user.id,
          cliente_id: cliente._id
        }
      }
      const result = await v2_actionCriarEstagioFunil(cliente._id, data);
      if (result.status === 200) {
        onCallback();
        setNome('');
        onClose()
      }
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <Popover open={open} onOpenChange={onClose}>
      <PopoverTrigger asChild>
        <div />
      </PopoverTrigger>
      <PopoverContent className="w-80 p-6">
        <div className="flex flex-col space-y-4">
          <div className="flex space-x-2">
            <Input
              value={nome}
              placeholder="Nome estágio"
              onChange={(event) => setNome(event.target.value)}
            />
          </div>

          <Button 
            onClick={handleCriarEstagioFunil}
            disabled={loading}
          >
            {loading ? "Salvando..." : "Salvar"}
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}


